module.exports = __webpack_public_path__ + "img/imgSrc3.144f8898.png";